// components/layout/LandingLayout.jsx
import Header from "./LandingHeader";
import Footer from "./LandingFooter";
import { Box } from "@mui/material";

export default function LandingLayout({ children }) {
  return (
    <>
      <Header />
      <Box component="main">{children}</Box>
      <Footer />
    </>
  );
}
